import api from '@/libs/axiosInstance';
import type { ApiResponse, BrandTermsSettings, PayloadLocale } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

export const brandTermsQueryKey = (brandId: string, locale: PayloadLocale) =>
  ['brand-terms', brandId, locale] as const;

export const useBrandTermsQuery = (
  brandId: string | undefined,
  locale: PayloadLocale,
  enabled = true
) =>
  useQuery({
    queryKey: brandTermsQueryKey(brandId ?? '', locale),
    queryFn: async (): Promise<BrandTermsSettings> => {
      const { data } = await api.get<ApiResponse<BrandTermsSettings>>('/dashboard/brand-terms', {
        params: { locale },
      });
      if (!data.success || !data.data) throw new Error(data.message);
      return data.data;
    },
    enabled: Boolean(brandId && enabled),
    retry: 1,
  });
